import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

export const isAnalyzingComponentRequestActive = createSelector(
  (state: RootState) => state.asyncRequests,
  (asyncRequests) =>
    Object.values(asyncRequests).some((requestData) => requestData !== undefined && requestData.type === 'analyze'),
);
